// extracted by mini-css-extract-plugin
export default {"wrapper":"bear-loader-module--wrapper--4e923","loaderImage":"bear-loader-module--loaderImage--12814"};